<template>
  <div class="changeImgBox">
    <div id="editProfileTitleRow">
      <div>
        <p class="boldEditTitle">Set Group Image</p>
      </div>
      <button class="closeEdit" @click="closeChangeImage()"></button>
    </div>
    <div class="setImageRow">
      <div class="setImageColumn">
        <img class="changeImageCurrent" :src="currentImage" />
        <p class="boldEditTitle">{{ groupName }}</p>
        <p>Upload Image:</p>
        <vue-dropzone
          ref="imgAttachDropZone"
          class="uploadNewImage"
          id="attachDropzone"
          :include-styling="false"
          :options="dropzoneOptions"
          @vdropzone-complete="afterAttach"
        ></vue-dropzone>
      </div>
      <div class="setImageColumn">
        <div class="defaultImgBox">
          <div
            class="defaultImgBackground"
            :class="{ isSelected: currentImg == currentImage }"
            v-for="(currentImg, index) in listOfDefault"
            :key="index"
            @click="setNewCurrent(index)"
          >
            <img class="defaultImg" :src="currentImg" />
          </div>
        </div>
      </div>
    </div>
    <div id="saveNewImage">
      <button class="saveButtonSetImg" @click="saveImage()">
        Save Image
      </button>
    </div>
  </div>
</template>

<script>
//import { mapActions, mapState } from "vuex";
import { mapState } from "vuex";
import db from "@/db";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import firebase from "@/firebase";

export default {
  components: {
    vueDropzone: vue2Dropzone,
  },

  data: () => ({
    currentImage: "",
    uploadedFile: null,
    hasChanged: false,
    uploadedNew: false,
    listOfDefault: [
      "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultGroupImages%2FdefaultCourselnk.png?alt=media&token=100b4b81-8e89-42fc-95af-c11398a2505d",
      "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultGroupImages%2FdefaultStar.png?alt=media&token=5b07bfb4-2c38-40d3-96d1-2ad3755fe99a",
      "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultGroupImages%2FdefaultBook.png?alt=media&token=fcb9a1b7-64bc-4122-8da8-826539a3b236",
      "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultGroupImages%2FdefaultHeart.png?alt=media&token=cef41f31-d588-40e2-b56d-f33391845a03",
      "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultGroupImages%2FdefaultMusic.png?alt=media&token=fe148d60-9b8f-4aaf-ab93-76910afc0106",
      "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultGroupImages%2FdefaultCode.png?alt=media&token=9954e690-d171-4594-8128-ad77aa7014d3",
      "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultGroupImages%2FdefaultBasketball.png?alt=media&token=5adaec31-7da1-4032-8012-5a4c3029f8cf",
      "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultGroupImages%2FdefaultSoccer.png?alt=media&token=abc4831c-a5a1-459f-8622-5fda2782d4fd",
      "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultGroupImages%2FdefaultMountain.png?alt=media&token=911f0fd3-073a-4115-92b3-6e6875b07654",
      "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultGroupImages%2FdefaultCake.png?alt=media&token=7e198e47-6a77-464b-aaa3-8d20bbf9473a",
      "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultGroupImages%2FdefaultChemistry.png?alt=media&token=dce8ef31-dc85-4af8-9c9a-b252d2901083",
      "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultGroupImages%2FdefaultPlant.png?alt=media&token=5ff85334-b76d-48c3-942e-03148c13bba0",
      "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultGroupImages%2FdefaultSign.png?alt=media&token=96fd0a2e-139d-4435-b99f-7d39a1454770",
      "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultGroupImages%2FdefaultGear.png?alt=media&token=85ac51df-e8b5-45d8-b42e-db2bf2d78518",
      "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultGroupImages%2FdefaultPostit.png?alt=media&token=3c6f28a5-719b-4d88-a5cd-d0d74009e56e",
      "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultGroupImages%2FdefaultGraph.png?alt=media&token=0c7fc347-575d-4cc9-b3cd-b51b3f177424",
      "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultGroupImages%2FdefaultAct.png?alt=media&token=3fd35c79-5d93-41f1-9d45-4054916dea0f",
      "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultGroupImages%2FdefaultEducation.png?alt=media&token=87673eca-c45b-40fe-b80a-7a0a4ffc1f19",
      "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultGroupImages%2FdefaultHistory.png?alt=media&token=0a61c5a4-2d4d-4720-8c9f-894beb4f2ab0",
      "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultGroupImages%2FdefaultTalk.png?alt=media&token=ec306870-197b-4ecd-b21e-f5b107175bb6",
      "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultGroupImages%2FgroupPink.png?alt=media&token=1b51adb4-7379-41ba-a118-6bfbd5ae1630",
      "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultGroupImages%2FgroupRed.png?alt=media&token=5d2fcb19-519f-4266-96fd-a71794d94e8b",
      "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultGroupImages%2FgroupBlue.png?alt=media&token=59e33923-ac24-477b-8e46-7cd235333df5",
      "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultGroupImages%2FgroupOrange.png?alt=media&token=16676fe7-8a18-43c6-9129-0d96fa1be423",
      "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultGroupImages%2FgroupGreen.png?alt=media&token=bb717f63-38c0-4c66-a625-5c0a146f66de",
      "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultGroupImages%2FgroupCyan.png?alt=media&token=a80395f4-83eb-458d-a719-2ba26333845c",
      "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultGroupImages%2FgroupGray.png?alt=media&token=9933b919-02fc-4ff3-9d93-948121c81646",
      "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultGroupImages%2FgroupDarkGray.png?alt=media&token=d9b22bf8-29c1-4c9d-a1cd-dd0cfc92434c",
    ],
    dropzoneOptions: {
      url: "https://httpbin.org/post",
      thumbnailWidth: 150,
      thumbnailHeight: 150,
      maxFilesize: 5,
      maxFiles: 9,
      duplicateCheck: true,
      addRemoveLinks: true,
    },
  }),

  mounted() {
    this.setCurrentImage();
  },

  computed: {
    ...mapState("messageBoard", [
      "changingImage",
      "groupId",
      "groupName",
      "groupType",
    ]),
    ...mapState("user", ["user"]),
  },

  methods: {
    closeChangeImage() {
      this.$store.commit("messageBoard/setChangeImage", false);
    },
    setCurrentImage() {
      db.collection("groups")
        .doc(this.groupId)
        .get()
        .then((doc) => {
          this.currentImage = doc.data().profileImage;
        });
    },
    setNewCurrent(index) {
      this.currentImage = this.listOfDefault[index];
      this.hasChanged = true;
    },
    async afterAttach(file) {
      this.$refs.imgAttachDropZone.removeAllFiles(true);

      if (file["type"] === "image/jpeg" || file["type"] === "image/png") {
        this.hasChanged = true;
        this.uploadedNew = true;
        this.uploadedFile = file;
        this.currentImage = URL.createObjectURL(file);
      }
      //this.currentImage = this.$refs.imgAttachDropZone;
    },
    async saveImage() {
      const storageRef = firebase.storage().ref();
      //console.log(this.uploadedFile);
      if (this.hasChanged == true) {
        if (this.uploadedNew == true) {
          const fileRef = storageRef.child(
            `profileImages/${this.uploadedFile.name}.png`
          );
          await fileRef.put(this.uploadedFile);
          this.currentImage = await fileRef.getDownloadURL();
        }
        console.log(this.currentImage);
        await db
          .collection("groups")
          .doc(this.groupId)
          .update({
            profileImage: this.currentImage,
          });
      }
      this.closeChangeImage();
    },
  },
};
</script>

<style>
.changeImgBox {
  background-color: white;
  width: 700px;
  height: 460px;
  padding: 20px 20px 10px 20px;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 2;
  border-radius: 20px;
}
.closeEdit {
  position: absolute;
  height: 40px;
  width: 40px;
  border: none;
  border-radius: 50%;
  background-image: url("../assets/closeEdit.svg");
  background-color: #e0e0e0;
  cursor: pointer;
  z-index: 3;
  transform: translate(350px, -35px);
}
.closeEdit:hover {
  background-color: #cacaca;
}
.closeEdit:active {
  transform: translate(350px, -35px) scale(0.9);
}
.boldEditTitle {
  font-size: 20px;
  color: black;
  font-weight: bold;
}
.changeImageCurrent {
  height: 230px;
  width: 230px;
  border-radius: 50%;
  border: thin solid #e0e0e0;
}
.setImageRow {
  width: 100%;
  height: 360px;
  display: flex;
  flex-direction: row;
}
.setImageColumn {
  display: flex;
  flex-direction: column;
  width: 50%;
  align-items: center;
  justify-content: space-evenly;
}
.uploadNewImage {
  background: url("../assets/uploadImageIcon.svg") #f0f0f0 50% 50% no-repeat;
  border-radius: 5px;
  width: 250px;
  height: 40px;
  cursor: pointer;
}
.uploadNewImage:hover {
  background: url("../assets/uploadImageIcon.svg") 50% 50% no-repeat #e0e0e0;
}
.defaultImgBox {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
  overflow-y: auto;
  padding-top: 20px;
}
.defaultImg {
  height: 70px;
  width: 70px;
  border-radius: 50%;
  border: thin solid #e0e0e0;
}
.defaultImgBackground {
  padding: 5px;
  height: 80px;
  width: 80px;
  border-radius: 50%;
  cursor: pointer;
}
.defaultImgBackground:hover {
  background: #e0e0e0;
}
.isSelected {
  border-radius: 10px;
  background: #e0e0e0;
}
#saveNewImage {
  width: 100%;
  height: 50px;
  padding: 10px 0 0 0;
  border-top: lightgrey solid thin;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.saveButtonSetImg {
  width: 100%;
  height: 100%;
  color: rgb(9, 132, 227);
  font-weight: 600;
  font-size: 18px;
  border-radius: 5px;
  cursor: pointer;
  border: none;
  background-color: #0fb9b150;
}
.saveButtonSetImg:hover {
  background-color: #0fb9b190;
}
.saveButtonSetImg:active {
  transform: scale(0.97);
}
</style>
